import { render, staticRenderFns } from "./headerBarMailNotification.vue?vue&type=template&id=86691c7c&"
import script from "./headerBarMailNotification.vue?vue&type=script&lang=js&"
export * from "./headerBarMailNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports